import { render, staticRenderFns } from "./WidgetReviewsSquareGalleryMobile.vue?vue&type=template&id=88cb9404"
import script from "./WidgetReviewsSquareGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsSquareGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports